import React, { useState } from 'react';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import {
    Calendar,
    Clock,
    MoreHorizontal,
    Plus,
    Filter,
} from 'lucide-react';

export default function LeaveRequest() {
    const leaveRequests = [
        { id: 1, type: 'Serious Sick Leave', duration: '3 Days', dates: '10 Mar - 12 Mar, 2026', status: 'Pending', reason: 'High fever and flu symptoms' },
        { id: 2, type: 'Casual Leave', duration: '1 Day', dates: '05 Mar, 2026', status: 'Approved', reason: 'Personal family matters' },
        { id: 3, type: 'Medical Leave', duration: '5 Days', dates: '15 Feb - 20 Feb, 2026', status: 'Approved', reason: 'Post-surgery recovery' },
    ];

    return (
        <div className="flex h-screen bg-[#F8FAFC] overflow-hidden font-sans">
            <Sidebar />

            <main className="flex-1 overflow-y-auto px-8">
                <Header
                    title="Leave Management"
                    subtitle="Track and apply for your professional leave requests"
                >
                    <button className="flex items-center gap-2 px-4 py-2.5 bg-white border border-gray-100 rounded-xl text-[14px] font-bold text-gray-700 shadow-sm hover:bg-gray-50 transition-all">
                        <Filter size={18} className="text-gray-400" />
                        History
                    </button>

                    <button className="flex items-center gap-3 py-2.5 px-6 bg-blue-500 text-white rounded-xl text-[14px] font-bold shadow-lg shadow-blue-100 hover:bg-blue-600 transition-all">
                        <Plus size={18} />
                        Apply For Leave
                    </button>
                </Header>

                <div className="grid grid-cols-1 gap-6 mb-10 pb-10">
                    {leaveRequests.map((request) => (
                        <div key={request.id} className="bg-white rounded-[32px] border border-gray-100 shadow-sm p-8 hover:border-blue-100 transition-all group overflow-hidden relative">
                            <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-8">
                                <div className="flex-1">
                                    <div className="flex items-center gap-4 mb-4">
                                        <span className={`px-4 py-1.5 rounded-full text-[12px] font-black tracking-widest uppercase ${request.status === 'Approved' ? 'bg-emerald-50 text-emerald-500' :
                                                request.status === 'Pending' ? 'bg-amber-50 text-amber-500' :
                                                    'bg-rose-50 text-rose-500'
                                            }`}>
                                            {request.status}
                                        </span>
                                        <span className="text-gray-400 font-bold text-[14px]">Ref ID: #LR-{request.id}042</span>
                                    </div>

                                    <h3 className="text-[22px] font-black text-[#111827] mb-2 group-hover:text-blue-500 transition-colors uppercase tracking-tight">{request.type}</h3>
                                    <p className="text-gray-400 font-bold mb-6 italic">"{request.reason}"</p>

                                    <div className="flex flex-wrap items-center gap-6">
                                        <div className="flex items-center gap-3 text-gray-700 font-bold text-[15px]">
                                            <Calendar size={18} className="text-blue-500" />
                                            {request.dates}
                                        </div>
                                        <div className="flex items-center gap-3 text-gray-700 font-bold text-[15px]">
                                            <Clock size={18} className="text-blue-500" />
                                            Total {request.duration}
                                        </div>
                                    </div>
                                </div>

                                <div className="flex items-center gap-3 lg:border-l lg:border-gray-50 lg:pl-10">
                                    <button className="px-6 py-3 rounded-xl border border-gray-100 text-[14px] font-black text-gray-600 hover:bg-gray-50 transition-all">
                                        View Details
                                    </button>
                                    <button className="p-3 rounded-xl border border-gray-100 text-gray-400 hover:text-rose-500 hover:bg-rose-50 transition-all">
                                        <MoreHorizontal size={20} />
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </main>
        </div>
    );
}
